// Module
var code = "<a class=\"btn subFormControl recipeEditorBtn\" data-bind=\"click: Click\"> <span class=\"\"> <i class=\"fa fa-indent\"></i> <!--ko text: Label--><!--/ko--> </span> </a>";
// Exports
export default code;